import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { DialogService } from '../dialog.service'
import { InvalidSessionDialogComponent } from './invalid-session.component'

@Injectable()
export class InvalidSessionService {
    private static isDialogOpen = false
    private static allPendingResolves: ((r: boolean) => void)[] = []

    constructor(
        private dialog: MatDialog,
        private dialogService: DialogService
    ) {}

    openLoginDialog() {
        return new Promise<boolean>((resolve) => {
            InvalidSessionService.allPendingResolves.push(resolve)
            if (!InvalidSessionService.isDialogOpen) {
                const dialogOptions = this.dialogService.getDialogOptions({}, true)
                InvalidSessionService.isDialogOpen = true

                const dialog = this.dialog.open<InvalidSessionDialogComponent, unknown, boolean>(InvalidSessionDialogComponent, dialogOptions)
                dialog.afterClosed().subscribe((r) => {
                    this.resolveAllPending(!!r)
                    InvalidSessionService.isDialogOpen = false
                })
            }
        })
    }

    private resolveAllPending(value: boolean) {
        for (const resolve of InvalidSessionService.allPendingResolves) {
            resolve(value)
        }

        InvalidSessionService.allPendingResolves = []
    }
}
